import React from 'react';
import urls, { codeUrl } from '@/constants/urls';
import CreatedWithUrlToast from '@/components/toasts/CreatedWithUrlToast';

const SearchCreatedToast = ({ name, code }) => (
  <CreatedWithUrlToast
    className="aridhia-search-created-toast"
    messageId="toast.your.search"
    name={name}
    url={codeUrl(urls.SEARCHES, code)}
  />
);

export default SearchCreatedToast;
